import PersonDataProvider from '../../../../providers/PersonDataProvider';
import { CURRENCY_DATA_USAGE, CURRENCY_DOCUMENTS, CURRENCY_PUZZLE } from '../../../constants/systemBalance';
import { getHumanReadableFileSize } from '../../../helpers/FileHelper';
import { moneyFormatToSting } from '../../../helpers/MoneyHelpers';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import api, { modelName } from './api';


const PUZZLE_ICON = 'extension';
const DOCUMENT_ICON = 'description';
const DATA_USAGE_ICON = 'data_usage';

export const systemBalanceTypes = {
  init: {
    label: 'Zainicjowanie salda',
    value: 1,
    color: 'gray',
  },
  clientActivation: {
    label: 'Aktywacja klienta',
    value: 2,
    color: 'success',
  },
  ocr: {
    label: 'OCR',
    value: 3,
    color: 'orange',
  },
  manualRecharge: {
    label: 'Ręczne doładowanie',
    value: 4,
    color: 'darkgreen',
  },
  documentsAdd: {
    label: 'Dodanie dokumentu',
    value: 5,
    color: 'brown',
  },
  order: {
    label: 'Zakup',
    value: 6,
    color: 'success',
  },
  clientDeactivation: {
    label: 'Dezaktywacja klienta',
    value: 7,
    color: 'danger',
  },
  dataUsage: {
    label: 'Użycie danych',
    value: 8,
    color: 'blue',
  },
  dataRestore: {
    label: 'Przywrócenie danych',
    value: 9,
    color: 'darkblue',
  },
  staffActivation: {
    label: 'Aktywacja pracownika',
    value: 10,
    color: '#32c4cc',
  },
  staffDeactivation: {
    label: 'Dezaktywacja pracownika',
    value: 11,
    color: '#9f46a9',
  },
  renewSubscription: {
    label: 'Subskrypcja',
    value: 12,
    color: '#253386',
  },
};

const parseAmount = (item, key) => {
  const value = item[key];

  if (CURRENCY_PUZZLE == item.currency) {
    return moneyFormatToSting(value);
  }

  if (CURRENCY_DOCUMENTS == item.currency) {
    return parseInt(value);
  }

  if (CURRENCY_DATA_USAGE == item.currency) {
    return getHumanReadableFileSize(value, false, 1024);
  }

  return '-';
};

const getIcon = (item) => {
  if (CURRENCY_DOCUMENTS == item.currency) {
    return DOCUMENT_ICON;
  }

  if (CURRENCY_DATA_USAGE == item.currency) {
    return DATA_USAGE_ICON;
  }

  return PUZZLE_ICON;
};

export const parseAmountWithPrefix = (item) => {
  let key = 'change';
  if (item.currency === CURRENCY_DATA_USAGE) {
    key = '_change_in_bytes';
  }

  const prefix = parseFloat(item[key]) > 0 ? '+' : '';
  return `${ prefix }${ parseAmount(item, key) }`;
};

function prepareSourceDescription(item, source) {
  return (new PersonDataProvider(item[source]?.client?.person)).companyOrFullName || '-- brak danych --';
}

function parseAmountAfter(item) {
  let key = 'amount_after';

  if (item?._after_in_bytes) {
    key = '_after_in_bytes';
  }

  return parseAmount(item, key);
}

function prepareStaffDescription(item, source) {
  const fullName = [
    item[source]?.employee?.person?.name,
    item[source]?.employee?.person?.surname,
  ]
    .filter((name) => name)
    .join(' ');

  if (fullName) {
    return fullName;
  }

  return '-- brak danych --';
}

export default {
  actions: {},
  topRightActions: {},
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    action_type: column({
      label: 'Akcja',
      component: 'value-status',
      options: systemBalanceTypes,
    }),
    source_description: column({
      format: (item) => {
        if (item.source_crm_original) {
          return prepareSourceDescription(item, 'source_crm_original');
        }

        if (item.activated_crm_original) {
          return prepareSourceDescription(item, 'activated_crm_original');
        }

        if (item.activated_staff_original) {
          return prepareStaffDescription(item, 'activated_staff_original');
        }

        if (item.subscriptionorder_original) {
          return `Zamówienie nr ${ item.subscriptionorder_original }`;
        }

        if (item.subscriptionoffer) {
          return item.subscriptionoffer.label;
        }

        return item.invoice_number || '';
      },
    }),
    editor: column({
      label: 'Edytor',
      component: 'value-editor',
    }),
    created_at: column({
      label: 'Data zmiany',
    }),
    change: column({
      label: 'Zmiana',
      format: (item) => parseAmountWithPrefix(item),
    }),
    amount_after: column({
      label: 'Saldo',
      format: (item) => parseAmountAfter(item),
      icon: getIcon,
    }),
    crm_counter: column({
      label: 'Licznik',
      format: (item) => item.activated_crm_original ? item.crm_counter : '-',
    }),
  },
  vars: vars({
    noItemsText: 'Brak salda',
    sidebarLabel: 'Podgląd salda',
  }),
};
